// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__KH9OH","colMaxWidth":"Table_colMaxWidth__3rOuM"};